var Force = /** @class */ (function () {
    function Force() {
    }
    Force.convertMetricToImperial = function (valueMetric) { var valueImperial = valueMetric / Force.N_TO_LBF; return valueImperial.toFixed(4) + ' ' + Force.IMPERIALUNIT; };
    Force.displayMetric = function (valueMetric) { return valueMetric.toFixed(4) + ' ' + Force.METRICUNIT; };
    return Force;
}());
export { Force };
Force.N_TO_LBF = 4.448;
Force.IMPERIALUNIT = 'lbf';
Force.METRICUNIT = 'N';
